module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray-f118e453f2bc1fd0befe12a611ad2d3c.png";